export default __webpack_public_path__ + "static/media/caret.fd78e37e.svg";